export class SortZeroEtlPolicyBy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "ZeroEtlPolicySortField",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "SortOrder",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SortZeroEtlPolicyBy.attributeTypeMap;
    }
    constructor() {
    }
}
